import { useQuery } from "@tanstack/react-query";
import queryKey from "../../enumerations/queryKey";
import { apiGetLineLink } from "./service";

export const useGetLineUrl = (options: any) => {
  return useQuery<any>({
    queryKey: [queryKey.LINE_URL],
    queryFn: () => apiGetLineLink({}).then((res: any) => res.data.data),
    ...options,
  });
};
